import { useEffect, useState } from "react";
import { useAuth } from "../../../context/authProvider";
import { useWatches } from "../../../context/watchProvider";
import { IBuyerScore } from "../../../utils/buyerScore";
import BuyerScoreCard from "../../core/buyerScoreCard";

export default function MyBuyerScore() {

    const { userId } = useAuth();
    const { getBuyerScore } = useWatches();

    const [buyerScore, setBuyerScore] = useState<IBuyerScore | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const doGetScore = async () => {
            if (!userId) {
                setLoading(false);
                return null;
            }
            setLoading(true);
            const score = await getBuyerScore(userId);
            setBuyerScore(score);
            setLoading(false);
        }
        doGetScore();
        // eslint-disable-next-line
    }, [userId]);

    return (
        <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-xl shadow-primary/5 border border-primary/5 space-y-8 animate-superfade">
            <div className="space-y-2">
                <h2 className="text-2xl font-black text-primary tracking-tight">Meu Score</h2>
                <div className="w-12 h-1 bg-secondary" />
                <p className="text-mono text-sm">Este é o score que os anunciantes veem ao negociar com você.</p>
            </div>
            <BuyerScoreCard buyerScore={buyerScore} loading={loading} variant="full" />
        </div>
    )
}
